// Файл index.js

/**
 * Файл содержит интерфейсную логику отдельного сценария приложения.
 * Он связывает данные, состояние и общие компоненты пользовательского слоя.
 * Реализация избегает дублирования правил, вынесенных в общие модули.
 * Этот комментарий фиксирует назначение файла для сопровождения.
 */
import PDFViewer from './PDFViewer';



export default PDFViewer;
